import { useCallback } from 'react';
import { buildLoginRedirectUrl } from '@wix/gg-components';
import { useSetPendingRedirect, SESSION_STORAGE_KEY } from 'stores/appStore';
import { updateSessionStorageState } from 'utils/sessionStorage';
import { getInitialEmail } from 'config/client';

interface RedirectHandlerConfig {
  returnToStepId: string;
}

export function useRedirectHandler(config: RedirectHandlerConfig) {
  const setPendingRedirect = useSetPendingRedirect();

  const handleRedirect = useCallback(() => {
    const redirectData = {
      returnToStepId: config.returnToStepId,
      timestamp: Date.now(),
    };
    setPendingRedirect(redirectData);
    // Force Zustand persist to flush by directly writing to sessionStorage
    updateSessionStorageState(SESSION_STORAGE_KEY, (state) => {
      state.pendingRedirect = redirectData;
    });

    window.location.href = buildLoginRedirectUrl({ email: getInitialEmail() });
  }, [setPendingRedirect, config.returnToStepId]);

  return { handleRedirect };
}
